import React from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import axios from 'axios';
import Navbar from './../Navbar/navbar.jsx';
import { Table } from 'react-bootstrap';
import Loader from 'react-loader-spinner'
import _ from 'lodash'
import Moment from "moment";
import { isLogin } from './../../utils/authentication.js';

import { BACKEND_URL_MAIN as BACKEND_URL } from '../../config.js';


axios.defaults.headers.common['token'] = localStorage.getItem("token")


class Insights extends React.PureComponent {

  state = {
    data:  null,
    conent: null,
    type: 'PrecisionMedicine'
  }

  componentDidMount(){

    if(!isLogin()){
        this.props.history.push({
            pathname:"/login"
        });
    }

    this.getInsightContent()

    if(this.props.location.search){
      this.getInsights(this.props.location.search)
    } else{
      this.getInsights('?page=1')
    }
  }

  getInsightContent = () => {

    axios.get(
        BACKEND_URL + "/v1/insights/content"
      ).then((res) => {
        this.setState({content: res.data})
      }).catch((err) => {
        console.log(err)
      }
    )
  }

  handleDelete = (id)=> {
    let conf = confirm("Are you sure!");
    if(conf) {
      axios.post(
        BACKEND_URL + "/v1/insights/deleteInsight", {
          id: id
        }
      ).then((res) => {
        let oldResults = {...this.state.data}
        let newData = _.remove(oldResults.results, (n)=> {
          return id == n.id;
        });
        this.setState({data: oldResults})
      }).catch((err) => {
          console.log(err)
      })
    }
  } 

  onTypeChanged = (e)=> {
    this.setState({
        type: e.currentTarget.value
    }, () => {
        this.handleNext('?page=1')
    });
  }


  getInsights = (page)=> {
    axios.get(
      BACKEND_URL + "/v1/insights" + page, {
        params: {
          limit: 100,
          start_date: Moment().subtract(6, 'months').format("YYYY-MM-DD"),
          end_date: Moment().format("YYYY-MM-DD"),
          bis_industry_type: this.state.type
        }
      }
    ).then((res) => {
        this.setState({data: res.data})
    }).catch((err) => {
        console.log(err)
    })
  }

  handleNext = (page)=> {
    this.props.history.push(this.props.location.pathname + page)
    this.setState({data: null})
    this.getInsights(page)
  }


  render() {
    const { data, content } = this.state;
    return (
      <div>
        <div className="col-md-12 topbar">
            <Navbar />
        </div>

        <main role="main" className="p-5">
          <div className="my-3 p-3 bg-white rounded shadow-sm">
            <h6 className="border-bottom border-gray pb-2 mb-0">BIS Workspace</h6>
            <div className="card">
              <div className="card-body">
              <h5 className="card-title">BIS Insights - {data && data.results ? data.results.length : 'Loading...'} Results</h5>
              <div className="d-flex">
                  {content && content.feedList && content.feedList.map((o, index)=>
                    <div key={index} className="mr-4">
                      <label className="mr-2">{o.industry_name}</label>
                      <input type="radio"
                         value={o.industry_type}
                         checked={this.state.type === o.industry_type} 
                         onChange={this.onTypeChanged} />
                    </div>
                  ) }
                </div>

              {data && content ?
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Source</th>
                    <th>Tile</th>
                    <th>Summery</th>
                    <th style={{width: 150}}>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data && data.results && data.results.map((o, index)=>
                    <tr key={index}>
                      <td>{o.id}</td>
                      <td>{o.source_name}</td>
                      <td>{o.title}</td>
                      <td>{o.summary}</td>
                      <td>{Moment(o.pub_date).fromNow()}</td>
                      <td><button className="btn btn-danger btn-sm" onClick={()=> this.handleDelete(o.id)}>Delete</button></td>
                    </tr>
                  )}
                </tbody>
              </Table> :
              <div style={{textAlign: 'center'}}>
                <Loader
                 type="Oval"
                 color="#00BFFF"
                 height={100}
                 width={100}
                /> 
              </div> }
              { data && data.next && <div>Next Page: {data.next.split("=")[1]}</div> }

              { data && data.previous && <button className="btn btn-sucess btn-sm" onClick={()=> this.handleNext(data.previous)}>Previous</button> }
              { data && data.next && <button className="btn btn-sucess btn-sm ml-1" onClick={()=> this.handleNext(data.next)}>Next</button> }

              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

function mapStateToProps(state){
    return { }
}

export default withRouter(connect(
  mapStateToProps
)(Insights))




// WEBPACK FOOTER //
// ./src/components/Insights/Insights.js